import { render, staticRenderFns } from "./LoginSucc.vue?vue&type=template&id=475da1b8"
import script from "./LoginSucc.vue?vue&type=script&lang=js"
export * from "./LoginSucc.vue?vue&type=script&lang=js"
import style0 from "./LoginSucc.vue?vue&type=style&index=0&id=475da1b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports